export const getBaseSettings = () => {
  let baseSettings = {};

  return baseSettings;
};

export const LiveChatTracking = function () {
    if (window.localStorage.getItem("IsChatLink") === null) 
    {
      window.dataLayer.push({
                  event: "live_chat_open",
                  click_location : "floating-button",
                  click_text: "no click text"});
    } 
    else{
      window.dataLayer.push({
                  event: "live_chat_open",
                  click_location : "homepage_livechat_link_click",
                  click_text: "Live chat"});
      localStorage.removeItem("IsChatLink");
    }
  };

export const liveAgentSettings = (
  membershipNumber,
  firstName,
  lastName,
  fullName
) => {
  let settings = getBaseSettings();

  window.addEventListener("onEmbeddedMessagingReady", e => {
    window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
      // List the pre-chat field names with the value and whether
      // it's editable in the pre-chat form.
      "_firstName": {
        "value": firstName,
        "isEditableByEndUser": false
      },
      "_lastName": {
        "value": lastName,
        "isEditableByEndUser": false
      }
    });
  });

  window.addEventListener("onEmbeddedMessagingReady", () => {
    window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({ "MemberPlan": `${membershipNumber} - ${fullName}`});
  });

  
  if (!window.__chatButtonListenerAdded)
  {
    window.addEventListener("onEmbeddedMessagingButtonClicked", LiveChatTracking);
  }
  
  return settings;
};